import { compose } from 'recompose';

import LogoView from './LogoView';

export default compose()(LogoView);
